import { render, staticRenderFns } from "./ChangeApprove.vue?vue&type=template&id=01343baa&scoped=true"
import script from "./ChangeApprove.vue?vue&type=script&lang=js"
export * from "./ChangeApprove.vue?vue&type=script&lang=js"
import style0 from "./ChangeApprove.vue?vue&type=style&index=0&id=01343baa&prod&lang=scss"
import style1 from "./ChangeApprove.vue?vue&type=style&index=1&id=01343baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01343baa",
  null
  
)

export default component.exports